export function parseGroupedMessagePreview(message: string, hasGroupedExperts: boolean) {
  const trimmedMessage = message.trim();

  if (!hasGroupedExperts) {
    return { previewText: trimmedMessage };
  }

  const firstColonIndex = trimmedMessage.indexOf(':');

  if (firstColonIndex <= 0) {
    return { previewText: trimmedMessage };
  }

  const expertName = trimmedMessage.slice(0, firstColonIndex).trim();

  const previewText = trimmedMessage.slice(firstColonIndex + 1).trimStart();

  if (!expertName || !previewText) {
    return { previewText: trimmedMessage };
  }

  return { expertName, previewText };
}
